import script from "./vi-tabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./vi-tabs.vue?vue&type=script&setup=true&lang=ts"

import "./vi-tabs.vue?vue&type=style&index=0&id=270ed058&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270ed058"]])

export default __exports__